import { LevelRow } from '../types/survey';

function num(v: string): number | null {
  if (!v || v.trim() === '') return null;
  const n = Number(v);
  return Number.isFinite(n) ? n : null;
}

function fmt(v: number | null): string {
  return v === null ? '' : v.toFixed(3);
}

export function calculateRows(tbm: number, rows: LevelRow[]) {
  let currentRL = tbm;
  let currentHI: number | null = null;
  let currentChainage = '';

  return rows.map((row) => {
    const bs = num(row.bs);
    const isv = num(row.is);
    const fs = num(row.fs);

    if (row.chainage.trim()) {
      currentChainage = row.chainage;
    }

    let hi = '';
    let rl = '';

    if (bs !== null) {
      currentHI = currentRL + bs;
      hi = fmt(currentHI);
    }

    if (isv !== null && currentHI !== null) {
      rl = fmt(currentHI - isv);
    }

    if (fs !== null && currentHI !== null) {
      currentRL = currentHI - fs;
      rl = fmt(currentRL);
    }

    return {
      ...row,
      hi,
      rl,

     side: row.offset.trim() === ''
       ? 'Center'
       : row.side,

      ch: row.offset.trim() ? currentChainage : '',

      offsetSigned:
        row.offset.trim() === ''
          ? ''
          : row.side === 'Center'
          ? '0'
          : row.side === 'LHS'
          ? '-' + row.offset
          : row.side === 'RHS'
          ? row.offset
          : '',

      remarks: row.remarks
    };
  });
}
